import { mutationOptions, type QueryClient } from '@tanstack/react-query';

import {
  createDiscoverySession,
  createSearchModeMessage,
  type CreateSearchModeMessageRequest,
} from './api';
import { discoveryQueryKeys } from './query-keys';

export type CreateSearchModeMessageMutationRequest = {
  discoverySessionId: string;
  request: CreateSearchModeMessageRequest;
  signal?: AbortSignal;
};

export function createDiscoverySessionMutationOptions(
  queryClient: QueryClient,
  workspaceId: string,
) {
  return mutationOptions({
    mutationFn: () => createDiscoverySession(workspaceId),
    onSuccess: (session) => {
      if (!session) return;
      queryClient.setQueryData(discoveryQueryKeys.currentSession(workspaceId), session);
    },
  });
}

export function createSearchModeMessageMutationOptions() {
  return mutationOptions({
    mutationFn: ({ discoverySessionId, request, signal }: CreateSearchModeMessageMutationRequest) =>
      createSearchModeMessage(discoverySessionId, request, signal),
    scope: { id: 'discovery:chat' },
  });
}
